import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from "../../common/CustomModal";
import { useShipmentDetails } from './useShipmentDetails';
import { DELETE_IMPORT_PLANNING_BUDGET, LIST_COMMERCIAL_INVOICES, LIST_IMPORT_PLANNING_BUDGETS, LIST_PROFORMA_INVOICES } from '../../../services/apiRoutes';
import { genericPost } from '../../../services/authServices';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { getCurrencyList, getCommanImportShipmentId, } from '../../../services/CommonServices';
import { Box } from '@mui/material';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import BookOnlineOutlinedIcon from '@mui/icons-material/BookOnlineOutlined';
import CustomStatus from '../../common/CustomStatus';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import CreatePlanningBudgetImport from '../CreateForm/CreatePlanningBudgetImport';
import UpdatePlanningBudgetImport from '../UpdateForm/UpdatePlanningBudgetImport';
import PlanningBudgetImportView from '../ViewDetails/PlanningBudgetImportView';


export default function PlanningBudgetImport({ fetchButtonList }) {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const { importShipmentId } = useParams();
    const [open, setOpen] = useState(true);
    const [leadModal, setLeadModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const [planningBudgetId, setplanningBudgetId] = useState('');
    const [viewModal, setViewModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('planningBudgetImport');
    const [shippingLines, setShippingLines] = useState([]);
    const [portMasters, setPortMasters] = useState([]);
    const [fclData, setFCLData] = useState([]);
    const [directListData, setDirectListData] = useState([]);
    const [freightForwardAgencyData, setFreightForwardAgencyData] = useState([]);
    const [customClearingAgencyData, setCustomClearingAgencyData] = useState([]);
    const [cifFobList, setCIFFOBList] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const [proformaInvoiceList, setProformaInvoiceList] = useState([]);
    const [commercialInvoiceList, setCommercialInvoiceList] = useState([]);


    const { shipmentDetails, loading: shipmentLoading } = useShipmentDetails(importShipmentId);
    let supplierId, cifFob;

    const hasFetched = useRef(false);

    useEffect(() => {
        if (shipmentDetails) {
            supplierId = shipmentDetails.supplierId;
            cifFob = shipmentDetails.cifFob.cifFobName;
            fetchData();
            getCommonData();
            getProformaInvoice();
            getCommercialInvoice();
            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, planningBudgetId, leadModal, deleteAlert, token]);


    const getProformaInvoice = async () => {
        try {
            const payload = {
                supplierNamesId: supplierId,
                shipmentId: shipmentId,
            };

            const response = await genericPost(LIST_PROFORMA_INVOICES, payload);

            if (response.data && response.data.success && response.data.proformaInvoice) {
                const proform = response.data.proformaInvoice.map((invoice) => {
                    // ✅ Calculate total qty from all particulars
                    const totalQty = invoice.particulars?.reduce((sum, item) => {
                        return sum + Number(item.qty || 0);
                    }, 0);

                    return {
                        id: invoice.proformaInvoiceId || '',
                        title: invoice.proformaInvoiceNo || '',
                        totalQty: totalQty,
                    };
                });

                setProformaInvoiceList(proform);
            } else {
                setProformaInvoiceList([]);
            }
        } catch (error) {
            console.error('Error fetching proforma invoices:', error);
            setProformaInvoiceList([]);
        }
    };
    const getCommercialInvoice = async () => {
        try {
            const payload = {
                supplierNamesId: supplierId,
                shipmentId: shipmentId
            };
            const response = await genericPost(LIST_COMMERCIAL_INVOICES, payload, {
            });
            if (response.data && response.data.success) {
                const invoices = response.data.data.map((invoice) => ({
                    id: invoice.commercialInvoiceId,
                    title: invoice.commercialInvoiceNo,
                }));
                setCommercialInvoiceList(invoices);
            } else {
                console.error("No data available");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: supplierId,
                commanShipmentId: getCommanImportShipmentId,
                shipmentId: shipmentId,

            };
            const response = await genericPost(LIST_IMPORT_PLANNING_BUDGETS, payload, {
            });

            if (response.data.success && response.data.planningBudget) {
                const planningBudgetData = response.data.planningBudget.map((budget, index) => ({
                    index: (index + 1).toString().padStart(2, '0'),
                    planningBudgetId: budget.planningBudgetId,
                    userId: budget.userId,
                    companyId: budget.companyId,
                    commanShipmentId: budget.commanShipmentId,
                    clientCompanyId: budget.clientCompanyId,
                    shipmentId: budget.shipmentId,
                    currencyId: budget.currencyId,
                    baseCurrencyId: budget.baseCurrencyId,
                    shipmentOrgId: budget.shipmentOrgId,
                    proformaInvoiceId: budget.proformaInvoiceId,
                    proformaInvExpId: budget.proformaInvExpId,
                    commercialInvExpId: budget.commercialInvExpId,
                    commercialInvoiceId: budget.commercialInvoiceId,
                    seaFreight: `${budget?.currency?.currency_symbol || ''} ${budget.seaFreight || ''}`,
                    clearingAgencyCharge: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.clearingAgencyCharge || ''}`,
                    freightForwardAgencyCharge: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.freightForwardAgencyCharge || ''}`,
                    cfsLocalCharges: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.cfsLocalCharges || ''}`,
                    shippingLineCharges: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.shippingLineCharges || ''}`,
                    blCharges: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.blCharges || ''}`,
                    othersCharges: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.othersCharges || ''}`,
                    dutyCharge: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.dutyCharge || ''}`,
                    taxCharge: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.taxCharge || ''}`,
                    transportCharge: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.transportCharge || ''}`,
                    conversionRate: `${budget?.baseCurrency?.currency_symbol || ''} ${budget.conversionRate || ''}`,
                    createdAt: companyDateFormat(budget.createdAt),
                    updatedAt: companyDateFormat(budget.updatedAt),
                    baseCurrencyName: budget?.baseCurrency?.name || '',
                    currencyName: budget?.currency?.currency_name || '',
                    proformaInvoiceNo: budget?.ProformaInvoice?.proformaInvoiceNo || '',
                    proformaInvExp: budget?.ProformaInvExp || null,
                    commercialInvoice: budget?.CommercialInvoice || null,
                    commercialInvExp: budget?.CommercialInvExp || null,
                }));
                setData(planningBudgetData);
            } else {
                setError('No planning budgets found');
            }
        } catch (error) {
            setError('Error fetching planning budgets');
            console.error('Error fetching planning budgets', error);
        } finally {
            setLoading(false);
        }
    };

    if (!shipmentDetails) {
        return (
            <Box>
                <CustomLoader open={shipmentLoading} />
            </Box>
        );
    }
    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }


    const handleDelete = async (planningBudgetId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');
        try {
            const response = await axios.delete(DELETE_IMPORT_PLANNING_BUDGET(planningBudgetId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            if (response.status === 200) {
                setDeleteAlert(false);
                fetchButtonList();
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };



    const getCommonData = async () => {
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
    }

    const handleScrollTo = (menu) => {
        setActiveTab(menu);
    };

    const handleOpen = () => {
        setLeadModal(true);
    };

    const handleClose = () => {
        setLeadModal(false);
    };


    const handleUpdateClick = (id) => {
        setplanningBudgetId(id);
        setUpdateModal(true);
    };


    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setplanningBudgetId('');
    };

    const handleOpenView = (id) => {
        setplanningBudgetId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setplanningBudgetId('');
    };

    const handleViewClick = (id) => {
        handleOpenView(id);
    };

    const ShippingBookingCardColumns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            accessor: 'shipmentId', label: 'Shipment ID', id: 'shipmentId', styleAccessor: {
                textAlign: 'center'
            },
        },
        {
            accessor: 'proformaInvoiceNo', label: 'proforma Invoice', id: 'shipmentId', styleAccessor: {
                textAlign: 'center'
            },
        }, {
            accessor: 'seaFreight',
            label: 'Sea Freight',
            id: 'seaFreight',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'clearingAgencyCharge',
            label: 'Clearing Agency Charge',
            id: 'clearingAgencyCharge',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'freightForwardAgencyCharge',
            label: 'Freight Forward Agency',
            id: 'freightForwardAgencyCharge',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'cfsLocalCharges',
            label: 'CFS Local Charges',
            id: 'cfsLocalCharges',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'shippingLineCharges',
            label: 'Shipping Line Charges',
            id: 'shippingLineCharges',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'blCharges',
            label: 'BL Charges',
            id: 'blCharges',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'othersCharges',
            label: 'Other Charges',
            id: 'othersCharges',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'dutyCharge',
            label: 'Duty Charge',
            id: 'dutyCharge',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'taxCharge',
            label: 'Tax Charge',
            id: 'taxCharge',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'transportCharge',
            label: 'Transport Charge',
            id: 'transportCharge',
            styleAccessor: { textAlign: 'right' },
        }, {
            accessor: 'conversionRate',
            label: 'Conversion Rate',
            id: 'conversionRate',
            styleAccessor: { textAlign: 'right' },
        },

        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.planningBudgetId)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.planningBudgetId)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.planningBudgetId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];


    const shipmentId = shipmentDetails.shipmentId;
    const companyName = shipmentDetails.supplier.clientCompanyName;
    const phoneNumber = shipmentDetails.supplier.mobile;
    const clientCompanyId = shipmentDetails.supplierId;
    const cifFobId = shipmentDetails.cifFobId;
    const currencySymbol = shipmentDetails?.company?.baseCurrencyData?.currency_symbol ?? '';
    const baseCurrencyId = shipmentDetails?.company?.baseCurrencyData?.id ?? '';
    const currencyId = shipmentDetails.currencyId;
    const currencySym = shipmentDetails?.currency?.currency_symbol ?? '';
    const shipmentOrgId = shipmentDetails.importShipmentId;
    const portOfLoading = shipmentDetails?.portOfLoading ?? '';
    const portOfDestination = shipmentDetails?.portOfDestination ?? '';

    return (
        <div>
            <CustomLoader open={loading} />
            <DetailsPageCard
                Icon={BookOnlineOutlinedIcon}
                columns={ShippingBookingCardColumns}
                title={'Planning & Budget'}
                buttonTitle={'Create Planning & Budget'}
                handleOpen={handleOpen}
                data={data}
                loading={loading}
                error={error}
            />
            <CustomModal open={leadModal}  >
                <CreatePlanningBudgetImport
                    fetchData={fetchData}
                    clientCompanyId={clientCompanyId}
                    commanShipmentId={getCommanImportShipmentId}
                    shipmentId={shipmentId}
                    currencyList={currencyList}
                    currencyId={currencyId}
                    currencySymbol={currencySymbol}
                    baseCurrencyId={baseCurrencyId}
                    currencySym={currencySym}
                    setMessage={setMessage}
                    handleClose={handleClose}
                    shipmentOrgId={shipmentOrgId}
                    fetchButtonList={fetchButtonList}
                    proformaInvoiceList={proformaInvoiceList}
                    commercialInvoiceList={commercialInvoiceList}

                />
            </CustomModal>

            <CustomModal open={updateModal}  >
                <UpdatePlanningBudgetImport
                    fetchData={fetchData}
                    setMessage={setMessage}
                    handleClose={handleCloseUpdate}
                    planningBudgetId={planningBudgetId}
                    clientCompanyId={clientCompanyId}
                    currencyList={currencyList}
                    proformaInvoiceList={proformaInvoiceList}
                    commercialInvoiceList={commercialInvoiceList}
                />
            </CustomModal>

            <CustomModal
                open={viewModal}
                modalStyles={{
                    maxHeight: '70vh',
                    top: "10%",
                }}
                handleClose={handleCloseView}>
                <PlanningBudgetImportView
                    handleClose={handleCloseView}
                    fetchData={fetchData}
                    setMessage={setMessage}
                    planningBudgetId={planningBudgetId}
                />
            </CustomModal>
            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </div>
    );
}
